export { default as ForbiddenIllustration } from './illustration_403';
export { default as SeverErrorIllustration } from './illustration_500';
export { default as PageNotFoundIllustration } from './illustration_404';
export { default as AiRiskManagementIllustration } from './illustration_ai_risk';
